import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Location} from '@angular/common';
import {OcrService} from '../../../components/ocr/ocr.service';
import {OcrFileinfo} from '../../../domain/model/common/file/ocr-file-info.class';

import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import moment = require('moment');
import {FormErrors} from '../../../components/forms/validation/form-validator.class';
import {CountryService} from '../../../domain/model/info/country/country.service';
import {MonthPickerComponentModel} from '../../../components/forms/controls/monthpicker/month-picker.component';
import {AddressModel} from '../../../components/forms/controls/addresspicker/addresspicker.component';
import {AddressMapper} from '../../../domain/model/common/mappers/address-mapper.class';
import {Address} from '../../../domain/model/common/values/address.class';
import {
    FormManager,
    FormSubmissionStatusCode,
    FormSubmissionStatusReason
} from '../../../components/forms/form-manager.class';
import {Observable} from 'rxjs/Observable';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from '../../../../../node_modules/rxjs';
import {OtherEducationService} from '../../../domain/model/education/other/other-education.service';
import {AttendanceDuration} from '../../../domain/model/education/common/values/attendance-duration.class';
import {LocalDateInterval} from '../../../domain/model/common/values/local-date-interval.class';
import {isUndefined} from 'util';
import {PremedicalEducationService} from '../../../domain/model/education/premedical/premedical-education.service';
import {MedicalEducationService} from '../../../domain/model/education/medical/medical-education.service';
import {InternshipService} from '../../../domain/model/education/internship/internship.service';
import {ResidencyService} from '../../../domain/model/education/residency/residency.service';
import {Response} from '@angular/http';
import {Model, ModelMixin} from '../../../domain/model/common/model.class';
import {FellowshipOrPreceptorshipService} from '../../../domain/model/education/fellowship-or-preceptorship/fellowship-or-preceptorship.service';


export class EducationData {
    public education: string = 'Other';
    public data: any = new Education();
    public count: number = -1;
}

export class Education extends ModelMixin() implements Model<Education> {

    TYPE = Education;

    institution?: string;
    address: Address = new Address();
    attendance: AttendanceDuration = new AttendanceDuration();
}

enum NextScreenTransitioningStatus {
    NOT_TRANSITIONING = 1,
    TRANSITIONING
}

@Component({
    template: require('./files-education-page.component.html'),
    styles: [require('./files-education-page.component.scss')],
})
export class FilesEducationPageComponent implements OnInit, OnDestroy {

    file: OcrFileinfo;

    educationEntries: EducationData[] = [];

    formErrors: FormErrors = {};

    private id: string;
    private entryIndex: number = 0;

    private sub: any;
    private subRouter: any;

    states: Array<string> = [];
    usStates: Array<string> = [];
    canadaProvinces: Array<string> = [];
    countries: Array<string> = [];
    model: EducationData;
    page = 0;
    total = 0;
    originalContent: string = '';
    showWarningText = false;
    loading: boolean = false;

    educationOptions: string[] = [
        'Other',
        'Premedical',
        'Medical School',
        'Internships',
        'Residency',
        'Fellowship or Preceptorship'
    ];

    phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    attendanceDateConstrains = {
        minDate: moment().subtract(100, 'year'),
        maxDate: moment().add(5, 'year')
    };
    attendanceFromMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);
    attendanceToMonthPickerModel = new MonthPickerComponentModel(this.attendanceDateConstrains);

    nextScreenTransitioningStatuses = NextScreenTransitioningStatus;

    nextScreenTransitioningStatus: NextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;

    private readonly _addressMapper = new AddressMapper();

    readonly _form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm)
    set form(value: NgForm) {
        this._form$.next(value);
    }

    private readonly _formManager: FormManager<any>;

    constructor(protected ocrService: OcrService,
                readonly route: ActivatedRoute,
                protected countryService: CountryService,
                fmgm: FormManager.InjectedMembers,
                readonly otherEducationService: OtherEducationService,
                readonly premedicalEducationService: PremedicalEducationService,
                readonly medicalEducationService: MedicalEducationService,
                readonly residencyEducationService: ResidencyService,
                readonly internshipEducationService: InternshipService,
                readonly fellowshipEducationService: FellowshipOrPreceptorshipService,
                private readonly _router: Router,
                private readonly _location: Location
                ) {
        this._formManager = new FormManager(
            fmgm,
            this._form$.asObservable(),
            Observable.of(() => this.updateModelEntry()),
            undefined,
            false
        );
    }

    updateModelEntry(): Observable<Response> {
        if (this.model.education === 'Premedical') {
            return this.premedicalEducationService.updateCurrentUserModel(this.model.data);
        } else if (this.model.education === 'Medical School') {
            return this.medicalEducationService.updateCurrentUserModel(this.model.data);
        } else if (this.model.education === 'Internships') {
            return this.internshipEducationService.updateCurrentUserModelEntry(this.model.count, this.model.data);
        } else if (this.model.education === 'Residency') {
            return this.residencyEducationService.updateCurrentUserModelEntry(this.model.count, this.model.data);
        } else if (this.model.education === 'Fellowship or Preceptorship') {
            return this.fellowshipEducationService.updateCurrentUserModelEntry(this.model.count, this.model.data);
        } else {
            return this.otherEducationService.updateCurrentUserModelEntry(this.model.count, this.model.data);
        }
    }

    ngOnInit(): void {
        this.model = new EducationData();
        this._formManager.displayedErrors$.subscribe(errors => this.formErrors = errors);

        this.sub = this.route.params.subscribe(params => {
            const entryIndex = params['entry'];
            this.id = params['id'];
            this.entryIndex = entryIndex ? parseInt(entryIndex, 10) - 1 : 0;
        });
        this.subRouter = this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.loadContent(this.id, this.entryIndex);
            }
        });
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        this.subRouter.unsubscribe();
    }

    loadContent(id: string, entryIndex: number) {
        this.loading = true;
        //states and country info must be loaded first, then show entry data
        Observable.forkJoin(
            this.countryService.getStates(),
            this.countryService.getStatesForCountry('US'),
            this.countryService.getStatesForCountry('CA'),
            this.countryService.getCountriesProjection(),
            this.ocrService.file(id)
        ).subscribe(responses => {
            this.states = responses[0].map(s => s.name);
            this.usStates = responses[1].map(s => s.name);
            this.canadaProvinces = responses[2].map(s => s.name);
            this.countries = responses[3].map(c => c.name);
            this.file = responses[4];
            this.total = responses[4].parsingData.education.length;
            this.showEducationEntry(entryIndex);
            this.loading = false;
        });
    }

    showEducationEntry(entry: number) {
       let educationEntry = this.file.parsingData.education[entry];
        if (this.educationEntries.length > entry) {
           this.model = this.educationEntries[entry];
            this._form$.asObservable().first().subscribe(ngForm => ngForm.form.markAsDirty());
        } else {
            this.model = new EducationData();
            this.page = entry;
            if (educationEntry.educationCenter.length > 0) {
                this.model.data.institution = educationEntry.educationCenter[0];
            }
            let address = new Address();
            address.address1 = educationEntry.street;
            address.city = educationEntry.city;
            address.stateOrProvince = educationEntry.state;
            if (this.usStates.indexOf(educationEntry.state) > -1) {
                address.country = 'United States';
            } else if (this.canadaProvinces.indexOf(educationEntry.state) > -1) {
                address.country = 'Canada';
            }
            address.postalCode = educationEntry.zipCode;
            this.model.data.address = address;
            let attendanceDuration = new AttendanceDuration();
            attendanceDuration.duration = new LocalDateInterval();
            attendanceDuration.duration.from = educationEntry.from;
            attendanceDuration.duration.to = educationEntry.to;
            this.model.data.attendance = attendanceDuration;
            this.model.count = -1;
            this.educationEntries.push(this.model);
            this._form$.asObservable().first().subscribe(ngForm => ngForm.form.markAsDirty());
        }
        if (!isUndefined(this.originalContent)) {
            this.originalContent = educationEntry.originalContent.join('\n');
        }
    }

    validateExistingData(value: string) {
        this.showWarningText = false;
        if (value === 'Premedical') {
            this.premedicalEducationService.getCurrentUserModel().subscribe(
                data => {
                    if (data !== undefined && data.exists) this.showWarningText = true;
                }
            );
        } else if (value === 'Medical School') {
            this.medicalEducationService.getCurrentUserModel().subscribe(
                data => {
                    if (data !== undefined && data.exists) this.showWarningText = true;
                }
            );
        }
    }

    handleAddressUpdated(addressModel: AddressModel) {
        this._addressMapper.update(this.model.data.address, addressModel);
    }

    handleStateUpdated() {
        let state = this.model.data.address.stateOrProvince;
        if (state != null) {
            if (this.usStates.indexOf(state) > -1) {
                this.model.data.address.country = 'United States';
            } else if (this.canadaProvinces.indexOf(state) > -1) {
                this.model.data.address.country = 'Canada';
            }
        }
    }

    hasPreviousScreen(): boolean {
        return this.page > 0;
    }

    goToPreviousScreen() {
        if (this.hasPreviousScreen() && this.nextScreenTransitioningStatus === NextScreenTransitioningStatus.NOT_TRANSITIONING) {
            let url = this._router.createUrlTree(['', 'resume', 'education', this.id, this.page]).toString();
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.TRANSITIONING;
            this.page = this.page - 1;
            this.showEducationEntry(this.page);
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            this._location.go(url);
        }
    }

    hasNextScreen(): boolean {
        if (this.file) {
            return this.file.parsingData.education.length > 1 && (this.page + 1) < this.file.parsingData.education.length;
        } else {
            return false;
        }
    }

    goToNextScreen() {
        if (this.hasNextScreen() && this.nextScreenTransitioningStatus === NextScreenTransitioningStatus.NOT_TRANSITIONING) {
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.TRANSITIONING;
            this.page = this.page + 1;
            this.showEducationEntry(this.page);
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            let url = this._router.createUrlTree(['', 'resume', 'education', this.id, this.page + 1]).toString();
            this._location.go(url);
        } else {
            this._router.navigate(['', 'resume', 'view', this.id]);
        }
    }

    saveAndSkip() {
        this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.TRANSITIONING;
        if (this.model.count === -1) {
            let value = this.model.education;
            if (value === 'Other') {
                this.otherEducationService.countCurrentUserModelEntries()
                    .subscribe(count => {
                        this.model.count = count + 1;
                        this.save();
                    });
            } else if (value === 'Internships') {
                this.internshipEducationService.countCurrentUserModelEntries()
                    .subscribe(count => {
                        this.model.count = count + 1;
                        this.save();
                    });
            } else if (value === 'Residency') {
                this.residencyEducationService.countCurrentUserModelEntries()
                    .subscribe(count => {
                        this.model.count = count + 1;
                        this.save();
                    });
            } else {
                this.save();
            }
        } else {
            this.save();
        }
    }

    save() {
        this._formManager.save().subscribe(result => {
            const resultStatus = result.status;
            this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            if (resultStatus.code === FormSubmissionStatusCode.SUBMITTED) {
                this.goToNextScreen();
            }
            else if (resultStatus.code === FormSubmissionStatusCode.NOTSUBMITTED) {
                if (resultStatus.reason === FormSubmissionStatusReason.NOT_DIRTY) {
                    this._formManager.hasErrors$.first().subscribe(hasErrors => {
                        if (!hasErrors) {
                            this.goToNextScreen();
                        }
                    });
                }
            } else {
                this._handleBackendError(result);
                this.nextScreenTransitioningStatus = NextScreenTransitioningStatus.NOT_TRANSITIONING;
            }
        });
    }

    private _handleBackendError(result) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/resume/education/files-education-page.component.ts